import React, { useEffect } from 'react'
import { useURLStore } from './stateManagement/URLZustand';
import { useHistory } from 'react-router';
import { findFirstDictByPrefixAndSuffix } from '../foo/tree';
import { _ACTIVITY_ROOT, _TEMPLATE_A, _libName, _pathSeparator, _rootName } from './constants';
import { useTreeStore } from './stateManagement/treeZustand';
import TemplateA from './activity/TemplateA';
import CommonHeader from './CommonHeader';
import { IonButton, IonCol, IonGrid, IonIcon, IonPage, IonRow } from '@ionic/react';
import { arrowBack, gameController, home, library } from 'ionicons/icons';
import { useGlobalStore } from './stateManagement/globalZustand';

function Activity() {
    const {URLVars,getURLTo} = useURLStore();
    const history = useHistory();
    const { templateCode, activityCode } = URLVars;
    const { nodes } = useTreeStore();
    const {isParentMode} = useGlobalStore();
    let activityNodePath: string | undefined = undefined;
    let templateJSX = <></>;

    
 
    const activityPathPrefix = _rootName+_pathSeparator+_libName+_pathSeparator+_ACTIVITY_ROOT;
    // TODO: perform more checks here
    if(templateCode==="A" && activityCode !== undefined){
        
        let activityNode = findFirstDictByPrefixAndSuffix(nodes, activityPathPrefix, _TEMPLATE_A)
        activityNodePath = activityNode?.key;
        let questionsPath = activityNodePath!+_pathSeparator+"?"
        let questions = nodes[questionsPath];
        
        if(questions === undefined || 
            activityNodePath === undefined ||
            questions?.length === 0){
            history.push(getURLTo().activities());
        }else{
            let possibleActivityCodes = nodes[activityNodePath!].filter((x:string) => x !== "?");
            let questionsAndAnswers = (questions || []).reduce((obj: {[key: string]: any}, question) => {
                const answersPath = questionsPath+_pathSeparator+question;
                if (nodes[answersPath]) {
                obj[question] = nodes[answersPath];
                }
                return obj;
            }, {});
            if(questionsAndAnswers !== undefined){
                templateJSX = <TemplateA
                activityCode={activityCode}
                questionsAndAnswers={questionsAndAnswers}
                possibleActivityCodes={possibleActivityCodes!}
                 />
            }
        }
    }

    let extraJSX=<>
    <IonButton fill="solid" color="light" shape="round" onClick={() => {history.push(getURLTo().home())}}>
    <IonIcon slot="icon-only" color="dark" icon={home} size="large"></IonIcon>
    </IonButton>
    <IonButton fill="solid" color="light" shape="round" onClick={() => {history.push(getURLTo().activities())}}>
    <IonIcon slot="icon-only" color="dark" icon={gameController} size="large"></IonIcon>
    </IonButton>
    {isParentMode && activityNodePath !== undefined && <IonButton shape="round" fill="solid" color="light" size="large" onClick={()=>{history.push("/page/talk/"+activityNodePath)}} >
        <IonIcon slot="icon-only" color="dark" icon={library} size="large"></IonIcon>
        <IonIcon slot="icon-only" color="dark" icon={arrowBack} size="large"></IonIcon>
        <IonIcon slot="icon-only" color="dark" icon={gameController} size="large"></IonIcon>
    </IonButton>}</>;
    //history.push(getURLTo().home());
    return <>
        <IonPage>
            <CommonHeader extraJSX={extraJSX} />
            
            {templateJSX}
        </IonPage>
    </>;
}

export default Activity